module.exports = __webpack_public_path__ + "img/bar-chart.d5ebe5e9.svg";